import { render, staticRenderFns } from "./PortalVuexHandoff.vue?vue&type=template&id=787b444a&"
import script from "./PortalVuexHandoff.vue?vue&type=script&lang=js&"
export * from "./PortalVuexHandoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports